import type en from "../en/nav";
import type { Messages } from "../../types";

const fr: Messages<typeof en> = {
  overview: "Vue d’ensemble",
  onlineStore: "Boutique en ligne",
  builder: "Éditeur de boutique",
  pages: "Pages",
  navigation: "Navigation",
  media: "Médiathèque",
  languages: "Langues",
  assistant: "Assistant IA",
  catalog: "Catalogue",
  products: "Produits",
  collections: "Collections",
  inventory: "Stock",
  reviews: "Avis",
  sales: "Ventes",
  orders: "Commandes",
  returns: "Retours",
  customers: "Clients",
  discounts: "Réductions",
  growth: "Croissance",
  marketing: "Marketing",
  analytics: "Statistiques",
  settings: "Paramètres",
  payments: "Paiements",
  shipping: "Livraison",
  taxes: "Taxes",
  checkout: "Paiement (checkout)",
  domains: "Domaines",
  seo: "SEO et redirections",
  team: "Équipe",
  storeDetails: "Informations de la boutique",
  publish: "Lancement et publication",
  switchStore: "Changer de boutique",
  allStores: "Toutes les boutiques…",
  newStore: "+ Créer une boutique",
  planBilling: "Forfait et facturation",
  helpSupport: "Aide et support",
  openNav: "Ouvrir la navigation",
  closeNav: "Fermer la navigation",
  navLabel: "Navigation",
  storeNavLabel: "Boutique",
  notifications: "Notifications",
  notificationsUnread: "Notifications, {count} non lues",
  myStores: "Mes boutiques",
  accountSecurity: "Compte et sécurité",
  support: "Support",
  platformAdmin: "Administration de la plateforme",
  signOut: "Se déconnecter",
  stores: "Boutiques",
  billing: "Facturation",
  accountNav: "Compte",
  live: "En ligne",
  suspended: "Suspendue",
  notPublished: "Non publiée",
  viewStore: "Voir la boutique ↗",
  preview: "Aperçu ↗",
  suspendedBanner: "Cette boutique a été suspendue par la plateforme{reason}. Vos données sont en sécurité —",
  contactSupport: "contactez le support",
  publicAddress: "Adresse publique : {url}",
  language: "Langue",
  adminOverview: "Vue d’ensemble",
  adminUsers: "Utilisateurs",
  adminStores: "Boutiques",
  adminPlans: "Forfaits",
  adminAi: "IA et crédits",
  adminPayments: "Paiements",
  adminSupport: "Support",
  adminContent: "Contenu",
  adminHealth: "État du système",
  adminAudit: "Journal d’audit",
  adminEmails: "Journal des e-mails",
  merchantView: "Vue marchand",
  exit: "Quitter",
  skipToContent: "Aller au contenu",
};

export default fr;
